import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/lib/AuthContext";
import { LoadingBlock } from "@/components/Common";

export function ProtectedRoute({ children, roles }) {
    const { user, loading } = useAuth();
    const location = useLocation();
    if (loading) return <div className="p-8"><LoadingBlock rows={4} /></div>;
    if (!user) {
        const next = encodeURIComponent(location.pathname + location.search);
        return <Navigate to={`/login?next=${next}`} replace />;
    }
    if (roles && roles.length && !roles.includes(user.role)) {
        return (
            <div className="max-w-md mx-auto mt-20 p-6 rounded-xl border border-border bg-card text-center">
                <div className="text-lg font-semibold">Access denied</div>
                <div className="text-sm text-muted-foreground mt-1">
                    Your role <span className="font-medium">{user.role}</span> does not have access to this page.
                </div>
            </div>
        );
    }
    return children;
}
